import * as React from 'react';
import { Link } from 'react-router-dom';
import AdditionLogo from '../components/AdditionLogo';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

export default function RegistrationSuccess() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-green-50/30 to-emerald-50/30">
      <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex justify-center">
            <AdditionLogo />
          </div>
          
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white/80 backdrop-blur-sm py-8 px-4 shadow-soft sm:rounded-3xl sm:px-10 
              border border-gray-100/20 text-center">
              <div className="flex justify-center mb-4">
                <CheckCircleIcon className="h-16 w-16 text-green-500" />
              </div>
              
              <h2 className="text-2xl font-serif font-bold text-gray-900 mb-2">
                Registration Successful!
              </h2>
              
              <p className="text-gray-600 mb-6">
                Thank you for registering with Addition Credit Union. Your application is currently under review.
                We'll notify you via email once your account has been approved.
              </p>
              
              <div className="space-y-4">
                <p className="text-sm text-gray-500">
                  What happens next?
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>Our team will review your application</li>
                  <li>You'll receive an email notification about your account status</li>
                  <li>Once approved, you can log in using your credentials</li>
                </ul>
              </div>
              
              <div className="mt-8">
                <Link
                  to="/"
                  className="inline-flex justify-center py-3 px-4 border border-transparent 
                    rounded-xl shadow-sm text-sm font-medium text-white bg-[#123524] 
                    hover:bg-[#0d2318] focus:outline-none focus:ring-2 focus:ring-offset-2 
                    focus:ring-[#123524]/20 transition-colors"
                >
                  Return to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 